import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
export default class index extends Component {
    render() {
        return (
            <div className="sec-box">
               <div className="pt-sm-2 mobile-partner-box">
                    <Row>
                    <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/lifetime-warranty.svg`} alt="Lifetime Warranty" className="img-partner-mobile" />
                        </Col>
                        <Col className="pl-0 ipad-pad-l" xs>
                            <div className="work-sec-item pt-3">Lifetime Warranty</div>
                            <p className="content-box pt-sm-2 right-mobile-ssd">
                            India's only Apple Service Company to provide Lifetime Warranty on Display Repairs.
                        </p>
                        </Col> 
                    </Row>
                </div>
                <div className="pt-sm-2 mobile-partner-box">
                    <Row> 
                        <Col className="pr-0 work-box-container" xs>
                            <div className="work-sec-item pt-3 text-right">Repairs Done, Right In Front Of You!</div>
                            <p className="content-box pt-sm-3 right-mobile">
                            Get your device repaired stressfree! We repair the device at your location, in front of you.
                        </p>
                        </Col>
                        <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/repairs-infront.svg`} alt="Repairs Done, Right In Front Of You!" className="img-partner-mobile" />
                        </Col>
                    </Row>
                </div>
                <div className="pt-sm-2 mobile-partner-box">
                    <Row>
                    <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/door-repair.svg`} alt="Same Day Doorstep Service" className="img-partner-mobile" />
                        </Col>
                        <Col className="pl-0 ipad-pad-l" xs>
                            <div className="work-sec-item pt-3">Same Day Doorstep Service</div>
                            <p className="content-box pt-sm-2 right-mobile-ssd">
                            Apple Repair Service is now quick & convenient with GadgetZippy.com.
                        </p>
                        </Col> 
                    </Row>
                </div>
                <div className="pt-sm-2 mobile-partner-box">
                    <Row> 
                        <Col className="pr-0 work-box-container" xs>
                            <div className="work-sec-item pt-3 text-right">Highest Google Ratings</div>
                            <p className="content-box pt-sm-3 right-mobile">
                            Most trusted Doorstep iPhone, iPad, iWatch & MacBook repair service in India
                        </p>
                        </Col>
                        <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/google-ratings.svg`} alt="Highest Google Ratings" className="img-partner-mobile" />
                        </Col>
                    </Row>
                </div> 
               
                <div className="pt-sm-2 mobile-partner-box">
                    <Row>
                        <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/lowest-prices.svg`} alt="Lowest Prices" className="img-partner-mobile" />
                        </Col>
                        <Col className="pl-0 ipad-pad-l" xs>
                            <div className="work-sec-item pt-3">Lowest Prices</div>
                            <p className="content-box pt-sm-2 right-mobile-ssd">
                            Value for money repairs make sure you get the best quality service at the best prices.
                        </p>
                        </Col>
                    </Row>
                </div>
                <div className="pt-sm-2 mobile-partner-box">
                    <Row>
                        <Col className="pr-0 work-box-container" xs>
                            <div className="work-sec-item pt-3 text-right">Expert Technicians</div>
                            <p className="content-box pt-sm-2 right-mobile">
                            17+ Years of Repairs Experience. We deliver Professional Repair Services at Doorstep.
                        </p>
                        </Col>
                        <Col md={2} xs={4}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/expert-tech.svg`} alt="Expert Technicians" className="img-partner-mobile" />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}
